import type {
  Buergschaftsauftrag,
  BuergschaftsauftragMitteilungDetails,
} from '@/types/Buergschaftsauftrag';
import { SharedBuergschaftsauftragService } from '@/shared/api/services/buergschaftsauftrag.ts';
import type { DeclineAuftragDto } from '@/auftraggeber/types/Auftrag.ts';

export class BuergschaftsauftragService extends SharedBuergschaftsauftragService {
  async storniereBuergschaftsauftrag(id: number | string): Promise<Buergschaftsauftrag> {
    return this.httpClient.post(`${this.baseUrl}/${id}/stornierung`);
  }

  async storniereBuergschaftsauftragInZweitpruefung(id: number): Promise<void> {
    return this.httpClient.post(`${this.baseUrl}/${id}/zweitpruefung/stornierung`);
  }

  async holeBuergschaftsauftragMitteilungDetails(
    id: number,
  ): Promise<BuergschaftsauftragMitteilungDetails> {
    return this.httpClient.get(`${this.baseUrl}/${id}/mitteilungdetails`);
  }

  async acceptZweitpruefung(auftragId: number): Promise<void> {
    return this.httpClient.post(`${this.baseUrl}/${auftragId}/zweitpruefung/akzeptieren`);
  }

  async declineZweitpruefung(auftragId: number, ablehnungData: DeclineAuftragDto): Promise<void> {
    return this.httpClient.post(`${this.baseUrl}/${auftragId}/zweitpruefung/ablehnen`, {
      data: ablehnungData,
    });
  }
}
